import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('translationManager', ['translationStatus']),
    useTranslateReview() {
      return this.translationStatus === 'on';
    },
    showTranslateButton() {
      return (
        this.reviewSettings.use_google_translation &&
        this.reviewSettings.use_translate_button
      );
    }
  },
  methods: {
    ...mapActions('googleTranslator', [
      'runTranslation',
      'restoreTranslation',
      'storeTranslationStatus'
    ]),
    onChangeTranslateReview(value) {
      value ? this.runTranslation() : this.restoreTranslation();
      this.storeTranslationStatus(value ? 'on' : 'off');
    }
  }
};
